import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router'
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone'
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

import { AppComponent } from './app/app.component'
import { routes } from './app/app.routes'
import { accessTokenInterceptor } from './app/shared/interceptors/auth.interceptor'
import { httpErrorsInterceptor } from './app/shared/interceptors/http-errors.interceptor'
import { loaderInterceptor } from './app/shared/interceptors/loader.interceptor'
import { provideFeatureFlag } from './app/shared/providers/feature-flag.provider'
import { provideMaintenance } from './app/shared/providers/maintenance-mode.provider'
import { provideWhiteLabelPermission } from './app/shared/providers/white-label.provider'
import { MobilePreloadingStrategy } from './app/shared/services/mobile-preloading-strategy.service'
import { environment } from './environments/environment'
import { initializeFaroRUM } from './faro/faro.config'

if (environment.production) {
	enableProdMode()
}

initializeFaroRUM()

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json')

bootstrapApplication(AppComponent, {
	providers: [
		provideAnimationsAsync(),
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		provideIonicAngular(),
		provideRouter(routes, withPreloading(MobilePreloadingStrategy)),
		provideHttpClient(withInterceptorsFromDi(), withInterceptors([accessTokenInterceptor, httpErrorsInterceptor, loaderInterceptor])),
		provideTranslateService({
			loader: {
				provide: TranslateLoader,
				useFactory: httpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		provideMaintenance(),
		provideFeatureFlag(),
		provideWhiteLabelPermission(),
	],
})
